import http from "../../utils/http";

// 프로필 목록
export const getExternalProfiles = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/employees/external-profile/list/${idx}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const addExternalProfiles = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/employees/external-profile`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editExternalProfiles = (idx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/employees/external-profile/${idx}`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const deleteExternalProfiles = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/employees/external-profile/`, { data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const getExternalProfileWithEmployee = (employeeIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/employees/external-profile/employee/${employeeIdx}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};